export default {
    actions: {
        usaToolsBtn: 'USA tools',
    },
}
